const useCurrency = () => {
    const currencyFormat = (num) => {
        return num ? 'Php ' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : null
    }
    return currencyFormat
}

export default useCurrency